import { Card, CardContent } from '../../../shared/components/ui/Card';
import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface SummaryCardProps {
  icon: ReactNode;
  value: ReactNode;
  label: string;
}

export function SummaryCard({ icon, value, label }: SummaryCardProps) {
  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent sx={{ p: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        {icon}
        <Box>
          <Typography variant="h6" fontWeight={700}>{value}</Typography>
          <Typography variant="body2" color="text.secondary">{label}</Typography>
        </Box>
      </CardContent>
    </Card>
  );
} 